const graduation = {
  add_new: '新規卒業期追加',
  edit: '卒業期編集',
  period_number: '卒業期名',
  period_number_placeholder: '選択してください',
  period_number_no_data: "データが見つかりません",
  recruitment_start_date: '募集開始',
  learning_start_date: '講座開始時期',
  recruitment_start_date_memo:
    '設定した時間になったら、登録フォームに自動的に反映されます。',
  coach_authority_available: '講座提供利用開始',
  course_group_name: 'コーチ・課金設定',
  start_date_charging: '課金開始',
  cancel_button: 'キャンセル',
  save_button: '保存',
  save_confirm: {
    title: '更新確認',
    content:
      'ご指定の卒業期情報を更新します。よろしいでしょうか。\n※更新内容は登録フォームに反映され、既存ユーザーの課金状態に影響を与える可能性がありますので、ご留意ください。',
    cancel: 'キャンセル',
    save: 'はい',
  },
  save_success: '新しい卒業期を作成しました。',
  edit_success: 'ご指定の卒業期を更新しました。',
  graduation_name_already_exists:
    'ご登録の卒業期は既に存在しますため、登録できません。再度お試しください。',
  due_public_date_error: "ご指定の卒業期は変更できない状態になりましため、引き続き変更できません。再度ご確認ください。",
  group_name: 'コース名',
  group_name_placeholder: '入力してください。',
  add_group: 'グループを追加',
  art_shift_content: 'ART SHIFTコンテンツ',
  content_count: '{{value}} 件',
  lesson_name_column: '受講可能 / コンテンツ名',
  unit_limit_column: '閲覧できるユニット数',
  lesson_usage_right: '利用権',
  unit_all: '全て',
  unit_placeholder: '選択',
  lesson_no_data: 'データが見つかりません',
  lesson_load_failed:
    'ART SHIFTコンテンツの一覧を取得できませんでした。画面を再読み込みしてください。',
  lesson_not_ready:
    'ART SHIFTコンテンツの一覧を読み込んでいます。しばらくお待ちください。',
  permission_sync_running:
    'コーチの権限を同期しています。完了までしばらくお待ちください。',
  permission_sync_done: 'コーチの権限の同期が完了しました。',
  permission_sync_failed:
    'コーチの権限の同期に失敗しました。お手数ですが、もう一度保存してください。',
  permission_sync_check_failed:
    '同期状況を確認できませんでした。通信環境をご確認のうえ、画面を再読み込みしてください。',
  lesson_error: {
    lessons_invalid: 'ART SHIFTコンテンツの設定内容が正しくありません。',
    lesson_id_required: 'コンテンツを指定してください。',
    is_shared_required: '利用権を指定してください。',
    unit_limit_min: '閲覧できるユニット数は1以上で指定してください。',
    lesson_id_duplicated: '同じコンテンツが重複しています。',
    is_available_required: '受講可能を指定してください。',
  },
  required: {
    period_number: '卒業期名を指定してください。',
    recruitment_start_date: '募集開始を指定してください。',
    recruitment_before_trial: '募集開始は講座提供利用開始より前の日付を選択してください。',
    coach_authority_available: '講座提供利用開始を指定してください。',
    trial_on_or_before_billing_month_first:
      '講座提供利用開始は、課金開始月の初日以前の日付を指定してください。',
    start_date_charging: '課金開始を指定してください。',
    learning_start_date: '講座開始時期を指定してください。',
    group_name: 'コース名を入力してください。',
    group_name_max: 'コース名は50文字以内で入力してください。',
    group_name_unique: '同一の卒業期名内でコース名は重複できません。',
  },
};

export default graduation;
